import * as React from "react";
import { SelectInput, required } from "react-admin";

const EditClient = () => (
  <SelectInput
    sx={{
      width: "20%",
      "@media (max-width:900px)": {
        width: "100%",
      },
    }}
    source="sex"
    label="resources.Client.fields.sex.name"
    choices={[
      { id: "female", name: "resources.Client.fields.sex.female" },
      {
        id: "male",
        name: "resources.Client.fields.sex.male",
      },
    ]}
    validate={required()}
  />
);

export default EditClient;
